import React from "react";
import { Row, Col } from "antd";
import { GRID_BOX_TYPE } from "../constant";
import style from "../style";
import { useRequisitionBranchContext } from "../context";

const GridBoxComponent = () => {
  const { state } = useRequisitionBranchContext();
  const { grid_summary } = state || {};
  return (
    <div>
      <Row gutter={16}>
        {GRID_BOX_TYPE.map((item) => (
          <Col key={item.key} span={4}>
            <div style={item.style}>
              <p style={style.gird_box.text}>
                {item.text} : <span>{grid_summary[item.key]}</span>
              </p>
            </div>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default GridBoxComponent;
